import { Tooltip } from 'antd';
import React, { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ApprovalWorkflowItemDto } from '@api/Api';
import Status from '@components/Approval/Status';
import AvatarsGroup from '@components/AvatarsGroup/AvatarsGroup';
import DueDate from '@components/Tasks/DueDate';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import { isDateSameOrBefore } from '@helpers/compareDueDate';
import { useCurrentTime } from '@hooks/useCurrentTime';

type ApprovalItemProps = {
  approvalWorkflow: ApprovalWorkflowItemDto;
};
export default memo(function ApprovalItem({
  approvalWorkflow
}: ApprovalItemProps) {
  const now = useCurrentTime();
  const firstAsset = approvalWorkflow?.assets?.[0];
  const imgUrl = assetPreviewThumbnails({
    url: firstAsset?.previewUrl || '',
    status: 'ready',
    type: firstAsset?.type || ''
  });

  const currentAwStageId = approvalWorkflow?.currentStageId;

  const currentStage = useMemo(() => {
    return approvalWorkflow?.stages.find((it) => it.id === currentAwStageId);
  }, [currentAwStageId, approvalWorkflow?.stages]);

  const currentStageDeadline = currentStage?.deadline;

  const isPastDueDate = useMemo(() => {
    return isDateSameOrBefore({
      dateToCompare: currentStageDeadline,
      baseDate: now
    });
  }, [now, currentStageDeadline]);

  const stageReviewers = useMemo(() => {
    if (!currentStage) return [];
    return currentStage.members;
  }, [currentStage]);
  return (
    <div className="approval_item">
      <div className="approval_item__preview">
        <a href={approvalWorkflow?.url} target="_blank" rel="noreferrer">
          {typeof imgUrl === 'string' ? (
            <img
              src={imgUrl}
              alt={firstAsset?.name}
              style={{ width: '100%', height: '100%' }}
            />
          ) : (
            imgUrl
          )}
        </a>
      </div>
      <div className="approval_item__body">
        <div className="approval_item__body_title">
          <a
            href={approvalWorkflow?.url}
            target="_blank"
            className="copy"
            rel="noreferrer"
          >
            {firstAsset?.name}
          </a>
          <AvatarsGroup
            membersType="aw_stage_members"
            maxCount={1}
            users={stageReviewers}
            avatarSize={24}
          />
        </div>
        <div className="approval_item__bottom">
          {approvalWorkflow && (
            <Status
              status={approvalWorkflow.status}
              isPaused={approvalWorkflow.isPaused}
              deadline={currentStage?.deadline || null}
            />
          )}
          {currentStageDeadline && (
            <DueDate urgent={isPastDueDate} date={currentStageDeadline} />
          )}
          <div className="breadcrumbs">
            {approvalWorkflow?.campaignName && approvalWorkflow.campaignId && (
              <Tooltip
                overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                title={approvalWorkflow.campaignName}
                placement={
                  approvalWorkflow.campaignName.length > 30 ? 'left' : 'top'
                }
              >
                <Link
                  to={`/campaigns/single/${approvalWorkflow.campaignId}?tab=approvals&approvalId=${approvalWorkflow.id}`}
                  className="approval_item__link"
                >
                  {approvalWorkflow.campaignName}
                </Link>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
